module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Star-494531077139a29feddf34985e7d4390.svg";